"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ImageMixin = require("../../mixins/components/ImageMixin");
/**
 * A simple `img` tag.
 *
 * @since 6.10.0
 */
var Image = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Image",
  componentId: "c11n-8-107-0__sc-1rtmhsc-0"
})(["", ""], _ImageMixin.ImageMixin);
exports.Image = Image;
Image.displayName = 'Image';
Image.propTypes = {
  /**
   * Images must have alt text or set this to empty string for
   * decorative images:
   * https://www.w3.org/WAI/tutorials/images/decorative/
   */
  alt: _propTypes.default.string.isRequired,
  /**
   * The image source.
   */
  src: _propTypes.default.string.isRequired
};

/** @component */